import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50d79520")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_vue_label = _resolveComponent("vue-label")

  return (_openBlock(), _createBlock(_component_vue_label, {
    class: "vue-content-edit-box",
    required: _ctx.required
  }, {
    label: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    content: _withId(() => [
      _createVNode(_component_select_box, {
        id: `${_ctx.keyValue}-prefs`,
        title: "pref",
        items: _ctx.prefKeyValueList,
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }, null, 8, ["id", "items", "modelValue"])
    ]),
    _: 1
  }, 8, ["required"]))
})